<template>
  <div class="addCount">
    <div class="page-title">
      {{ moduleTitle }}
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-button
        type="primary"
        size="small"
        class="editCount"
        v-show="!isEdit"
        @click="editCount"
      >
        编辑
      </el-button>
      <el-tab-pane label="基本配置" name="first">
        <source-info v-if="formSource.providerId=='wechat-work'"
          :formSource="formSource"
          :add="false"
          :edit="isEdit"
          @changeStatus="changeStatus"
        ></source-info>
        <orcid-info v-else-if="formSource.providerId=='orcid'" :formSource="formSource" @changeStatus="changeStatus" :add="false" :edit="isEdit"></orcid-info>
        <scan-info v-else-if="formSource.providerId=='wechat_open' || formSource.providerId=='weibo' || formSource.providerId=='wechat_mp'" :formSource="formSource" @changeStatus="changeStatus" :add="false" :edit="isEdit"></scan-info>
        <ding-info v-else-if="formSource.providerId=='ding_talk'" :formSource="formSource" @changeStatus="changeStatus" :add="false" :edit="isEdit"></ding-info>
        <cas-info v-else :formSource="casformSource" @changeStatus="changeStatus" :add="false" :edit="isEdit"></cas-info>
      </el-tab-pane>
      <!-- <el-tab-pane label="属性映射" name="second"> </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import sourceInfo from "@/components/certificationSource/sourceInfo.vue"
import casInfo from "@/components/certificationSource/casInfo.vue"
import orcidInfo from "@/components/certificationSource/orcidInfo.vue"
import scanInfo from "@/components/certificationSource/scanInfo.vue"
import dingInfo from "@/components/certificationSource/dingInfo.vue"
import APIS from "@/apis/certificationSource.js"

export default {
  components: {
    sourceInfo,
    casInfo,
    orcidInfo,
    scanInfo,
    dingInfo
  },
  data() {
    return {
      breadcrumb: [
        {
          label: "认证源",
          url: "/certificationSource"
        },
        {
          label: "认证源详情"
        }
      ],
      moduleTitle: "",
      id: '',
      formSource: {
        providerId: "",
        name: "",
        enabled: false,
        clientId: "",
        agentId: "",
        secret: "",
        wxip: location.host,
        // haveAccount: "0",
        // noAccount: "0",
        createMethod: "1"
      },
      casformSource: {
        providerId: "",
        name: "",
        enabled: true,
        casServerUrlPrefix: "",
        createMethod: "1"
      },
      realmName: this.$realm, //this.$realm,
      activeName: "first",
      isEdit: false,
      oldForm: null,
      oType: null
    }
  },
  created() {
    let id =  this.$route.query.sourceID, name = this.$route.query.name, form = null
    if(id !== 'cas'){
      form = this.formSource
      this.oType = 'w'
    } else {
      form = this.casformSource
      this.oType = 'c'
    }
    form.providerId = id
    form.name = name
    this.moduleTitle = name
  },
  computed: {},
  mounted() {
    this.getProviderBase()
  },
  methods: {
    editCount() {
      this.isEdit = !this.isEdit
    },
    // 获取认证源基本信息
    async getProviderBase() {
      let id = this.oType == 'w'? this.formSource.providerId : this.casformSource.providerId
      let { status, data } = await APIS.getProviderBase(
        this.realmName,
        id
      )
      if (status === 0) {
        if(this.oType == 'w'){
          this.formSource = data
          this.formSource.wxip = location.host
          this.formSource.secret = "******"
          this.oldForm = JSON.parse(JSON.stringify(this.formSource))
        } else {
          this.casformSource = data
          this.oldForm = JSON.parse(JSON.stringify(this.casformSource))
        }
      }
    },
    handleClick() {},
    changeStatus(type) {
      this.isEdit = false
      type
        ? (this.oType == 'w' ? this.formSource = JSON.parse(JSON.stringify(this.oldForm)) : this.casformSource = JSON.parse(JSON.stringify(this.oldForm)))
        : this.getProviderBase()
    }
  }
}
</script>

<style lang="scss">
</style>
